export function getBagnoLot(product_code, company_code, document_date) {

  const monthNames = ["A", "B", "C", "D", "E", "F",
    "G", "H", "I", "J", "K", "L"
  ];

  const d = document_date;
  return product_code + company_code + ("0" + parseInt(d.slice(-2))) + monthNames[parseInt(d.slice(-5,-3))-1];
}
